<template>
  <div class="content tunnel-step-3">
    <step-navbar :current-step="3"/>
    <div id="content" class="container" v-if="!loaded">
      <div class="page">
        <div class="loader">
          <loader/>
        </div>
      </div>
    </div>
    <div id="content" class="container" v-else>
      <extra-picker-date/>
      <div class="page">
        <div class="search--wrapper">
          <h3>{{ $t('extras.title.title1') }}</h3>
          <h4 v-html="$t('extras.title.title2', allExtras.length)"></h4>
        </div>
        <div class="main">
          <div class="room-container">
            <room-widget :room="room" :start="startDate" :end="endDate"/>
          </div>
          <div class="extras-container" v-if="hasPrice">
            <ul id="pushextra">
              <li v-for="(item, index) in extras" class="active" :key="item.id" :item="item" :index="index">
                <extra-main-widget
                    :item="item"
                    v-on:click-add="openExtraModal(item)"
                    v-on:extra-change="handleExtraChange"
                    :start-date="startDate"
                    :end-date="endDate"
                    :nb-guest="nbGuest"/>
              </li>
            </ul>
            <div class="all-extras" v-if="extrasLoading">
              <div class="loader">
                <loader/>
              </div>
            </div>
            <div id="allextras" v-if="!extrasLoading">
              <h3>{{ $t('extras.title.title3') }}</h3>
              <div id="filterextras">
                <form class="filterextras" method="post" id="allfilter">
                  <div id="fields" class="filterextra">
                    <ul class="btn-list">
                      <li
                          v-for="(category, index) in categories"
                          :key="category.id"
                          :index="index"
                          :class="{active: currentCategoryIndex === index}"
                          :item="category">
                        <button class="btn btn-select" v-on:click.prevent="selectCategory(index)"
                                :class="{active: currentCategoryIndex === index}">
                          <span>{{ category.text.title }}</span>
                        </button>
                      </li>

                      <li :class="{active: currentCategoryIndex === -1}" v-if="categories.length > 0">
                        <button class="btn btn-select" v-on:click.prevent="selectCategory(-1)"
                                :class="{active: currentCategoryIndex === -1}">
                          <span>{{ $t('extras.title.allBtn') }}</span>
                        </button>
                      </li>
                    </ul>
                  </div>
                </form>
              </div>
              <ul id="pushextra" v-if="!extrasLoading" class="extra-toggleable">
                <template v-for="(category, index) in categories" :index="index" :item="category">
                  <li v-for="(extra, i) in category.extras" :index="i" :key="extra.id" :item="extra"
                      :class="{active: index === currentCategoryIndex}">
                    <extra-main-widget
                        :item="extra"
                        v-on:click-add="openExtraModal(extra)"
                        v-on:extra-change="handleExtraChange"
                        :start-date="startDate"
                        :end-date="endDate"
                        :nb-guest="nbGuest"
                    />
                  </li>
                </template>
                <li v-for="(extra, i) in categoryAll" :index="i" :key="'_' + extra.id" :item="extra"
                    :class="{active: -1 === currentCategoryIndex}">
                  <extra-main-widget
                      :item="extra"
                      v-on:click-add="openExtraModal(extra)"
                      v-on:extra-change="handleExtraChange"
                      :start-date="startDate"
                      :end-date="endDate"
                      :nb-guest="nbGuest"
                  />
                </li>
              </ul>
            </div>
          </div>
          <div class="cart-container" v-if="hasPrice">
            <right-recap v-on:done="handleSaveCart"/>
          </div>
        </div>
        <div class="panel-message message-danger" v-if="!hasPrice">
          <p>{{ $t('shoppingCart.page.priceError') }}</p>
        </div>
        <div class="center" v-if="!hasPrice">
          <div class="btn--component">
            <a href="javascript:void(0)" v-on:click="handleEmptyShoppingCart"
               class="step3-delete">{{ $t('shoppingCart.page.btn.back') }}</a>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import RoomWidget from "./step2/room-widget";
import ExtraMainWidget from "./step3/extra-main-widget";
import {mapState} from "vuex";
import ExtraSecondWidget from "./step3/extra-second-widget";
import RightRecap from "./step3/right-recap";
import Loader from '../../components/loader.component';
import ExtraPickerDate from "./step3/extra-picker-date";
import Cover from "./parts/cover";
import StepNavbar from "./step-navbar";
import ResaPicker from "../rooms/components/resa-picker";

export default {
  components: {
    ResaPicker,
    StepNavbar,
    Cover,
    ExtraPickerDate,
    Loader,
    RightRecap,
    ExtraSecondWidget,
    ExtraMainWidget,
    RoomWidget
  },
  computed: {
    ...mapState({
      hasRoom: s => s.room.room !== null,
      roomLoading: s => s.shoppingCart.booking.bookingRoom.loading,
      room: s => {
        if (!s.shoppingCart.booking.bookingRoom.bookingRoom) return null;
        return s.shoppingCart.booking.bookingRoom.bookingRoom.room;
      },
      priceId: s => s.shoppingCart.booking.bookingRoom ? s.shoppingCart.booking.bookingRoom.bookingRoom.booking.room_price_id : null,
      startDate: s => s.shoppingCart.booking.bookingRoom ? s.shoppingCart.booking.bookingRoom.bookingRoom.booking.start : null,
      endDate: s => s.shoppingCart.booking.bookingRoom ? s.shoppingCart.booking.bookingRoom.bookingRoom.booking.end : null,
      extrasLoading: s => s.shoppingCart.booking.bookingRoom.extras.loading,
      extras: s => s.shoppingCart.booking.bookingRoom.extras.extras.sort((a, b) => (a.number - b.number)),
      allExtras: s => {
        const extras = [].concat(...s.shoppingCart.booking.bookingRoom.extras.categories
            .map(c => c.extras), s.shoppingCart.booking.bookingRoom.extras.extras, s.shoppingCart.booking.bookingRoom.extras.edge_by_room)
            .sort((a, b) => (a.number - b.number));
        const ids = extras.map(e => e.id);
        return extras.filter((item, index) => {
          return ids.indexOf(item.id) === index
        })
      },
      categoryAll: s => s.shoppingCart.booking.bookingRoom.extras.edge_by_room.sort((a, b) => (a.number - b.number)),
      categories: s => s.shoppingCart.booking.bookingRoom.extras.categories.map(c => {
        c.extras = c.extras.sort((a, b) => (a.number - b.number));
        return c;
      }),
      hasPrice: s => {
        for (const plan of s.shoppingCart.booking.bookingRoom.bookingRoom.price_plans) {
          for (const input of plan.input_prices) {
            if (input.edges.length === 0) return false;
          }
        }
        return true;
      },
      nbGuest: s => s.shoppingCart.booking.bookingRoom.bookingRoom.nb_guests,
      bookingIds: s => s.shoppingCart.bookings.map(b => b.id),
      shoppingCartLoading: s => s.shoppingCart.booking.bookingRoom.loading,
    }),
    bookingCount() {
      return this.$store.getters["shoppingCart/cartCount"];
    }
  },
  name: "step3",
  data() {
    return {
      currentCategoryIndex: -1,
      loaded: false
    }
  },
  methods: {
    async handleEmptyShoppingCart() {
      await this.$store.dispatch('scBooking/deleteAll');
      return this.$router.push({name: 'search'});
    },
    handlePageReload() {

    },
    selectCategory(index) {
      this.currentCategoryIndex = index;
    },
    async handleSaveCart() {
      window.scrollTo(0, 0);
      this.loaded = false;
      await this.$store.dispatch('shoppingCart/booking/bookingRoom/commit');
      await this.$router.push({name: 'step4'});
    },
    handleExtraChange({extra, value}) {
      this.$store.commit('shoppingCart/booking/bookingRoom/ADD_EXTRA', {extra, dates: value});
    },
    openExtraModal(extra) {
      const event = new CustomEvent('app:open-extra-picker.modal', {detail: extra});
      window.dispatchEvent(event);
    },
    async init() {
      this.loaded = false;
      try {
        await this.$store.dispatch('shoppingCart/booking/bookingRoom/fetch', this.$route.params.shoppingBookingId);
        await this.$store.dispatch('room/fetch', {
          id: this.$store.state.shoppingCart.booking.bookingRoom.bookingRoom.room.id,
          lang: this.$store.state.lang.currentLang
        })
        this.loaded = true;
      } catch (e) {
        this.$router.go(-1);
      }
    }
  },
  watch: {
    roomLoading(v) {
      this.loaded = !v;
    },
    bookingCount() {
      if (this.shoppingCartLoading) return;
      if (this.bookingIds.indexOf(parseInt(this.$route.params.shoppingBookingId)) === -1) {
        this.init().then().catch(console.error);
      }
    },
    $route(old, n) {
      if (old.name === n.name) {
        this.init().then().catch(console.error);
      }
    },
    async room() {
      if (this.room) {
        await this.$store.dispatch('shoppingCart/booking/bookingRoom/extras/fetch', {
          room_id: this.room.id,
          lang: this.$store.state.lang.currentLang
        });
        this.selectCategory(-1);
      }
    }
  },

  async mounted() {
    await this.init();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/tunnel/step3.vue